import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';

import { Suspense } from 'react';
import { Outlet, ReactLocation, Router } from 'react-location';
// import { ReactLocationDevtools } from 'react-location-devtools';

import Footer from 'common/components/Footer';
import pageCatalog from 'pages/pageCatalog';

const reactLocation = new ReactLocation();
const routes = Object.keys(pageCatalog).map((pageRef) => ({
  path: pageCatalog[pageRef].route,
  onMatch: () => {
    //Please refer to react location documentation for more info on this prop: https://react-location.tanstack.com/docs/api#route-properties
    window.scrollTo({ top: 0 });
    //Sending data to Adobe Analystics on route changes
    if (!!window.AWSMA && !!window.AWSMA.ready && !!window.AWSMA.TRIGGER_EVENT) {
      const options = {
        page: {
          pageURL: window.location.href.toLowerCase(),
        },
        event: {
          type: 'pageview',
          name: pageCatalog[pageRef].route,
        },
      };
      // Trigger a pageview call
      window.AWSMA.ready(function () {
        document.dispatchEvent(new CustomEvent(window.AWSMA.TRIGGER_EVENT, { detail: options }));
      });
    }
  },
  element: pageCatalog[pageRef].component,
}));

export const DefaultLayout = () => {
  return (
    <>
      <AppLayout
        navigationHide
        toolsHide
        disableContentPaddings
        footerSelector={'footer'}
        content={
          <Suspense fallback={<Spinner />}>
            <Router location={reactLocation} routes={routes}>
              <Outlet />
              {/* <ReactLocationDevtools initialIsOpen={false} /> */}
            </Router>
          </Suspense>
        }
      />
      <Footer />
    </>
  );
};
